
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/terms-of-service",
      function () {
        return require("private-next-pages/policy/terms-of-service/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/terms-of-service"])
      });
    }
  